import { Product } from './Product';
import { DrawableObject } from './DrawableObject';

export interface FrameProduct extends Product {
  imageUrl: string;
  minWidth: number;
  maxWidth: number;
  drawableObject: DrawableObject;
}
